module.exports = __webpack_public_path__ + "static/media/1.0586c655.mp3";